<div class="dialog">
    <div class="dialog-header">选择『经办人』和『会签部门』</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row no-border ">
                <div class="column no-border " [style.width]="'360px'">
                    选择主办部门经办人
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'60px'">
                    经办人1
                </div>
                <div class="column text-left" [style.width]="'100px'">
                    {{no_4_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第1经办人（选填）" [(ngModel)]="no_4_userId" [nzAllowClear]="true"
                        (ngModelChange)="onChange()">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_11_userId?.toString() || user.id!.toString() === no_10_userId?.toString() || user.id!.toString() === no_3_userId?.toString()">
                        </nz-option>
                    </nz-select>
                    <!-- <select [(ngModel)]="no_4_userId">
                        <option [value]="''">无需签字</option>
                        <option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [value]="user.id"
                            [disabled]="user.id!.toString() === no_11_userId?.toString() || user.id!.toString() === no_10_userId?.toString() || user.id!.toString() === no_3_userId?.toString()">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select> -->
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'60px'">
                    经办人2
                </div>
                <div class="column text-left" [style.width]="'100px'">
                    {{no_4_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第2经办人（选填）" [(ngModel)]="no_3_userId" [nzAllowClear]="true"
                        [nzDisabled]="!no_4_userId">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_11_userId?.toString() || user.id!.toString() === no_10_userId?.toString() || user.id!.toString() === no_4_userId?.toString()">
                        </nz-option>
                    </nz-select>
                    <!-- <select [(ngModel)]="no_3_userId">
                        <option [value]="''">无需签字</option>
                        <option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [value]="user.id"
                            [disabled]="user.id!.toString() === no_11_userId?.toString() || user.id!.toString() === no_10_userId?.toString() || user.id!.toString() === no_4_userId?.toString()">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select> -->
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'60px'">
                    <span class="color-danger">*</span> 负责人1
                </div>
                <div class="column text-left" [style.width]="'100px'">
                    {{no_4_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第1负责人（必填）" [(ngModel)]="no_11_userId" [nzAllowClear]="false">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_10_userId?.toString() || user.id!.toString() === no_3_userId?.toString() || user.id!.toString() === no_4_userId?.toString()">
                        </nz-option>
                    </nz-select>
                    <!-- <select [(ngModel)]="no_11_userId">
                        <option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [value]="user.id"
                            [disabled]="user.id!.toString() === no_10_userId?.toString() || user.id!.toString() === no_3_userId?.toString() || user.id!.toString() === no_4_userId?.toString()">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select> -->
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'60px'">
                    负责人2
                </div>
                <div class="column text-left" [style.width]="'100px'">
                    {{no_4_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第2负责人（选填）" [(ngModel)]="no_10_userId" [nzAllowClear]="true">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_11_userId?.toString() || user.id!.toString() === no_3_userId?.toString() || user.id!.toString() === no_4_userId?.toString()">
                        </nz-option>
                    </nz-select>
                    <!-- <select [(ngModel)]="no_10_userId">
                        <option [value]="''">无需签字</option>
                        <option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [value]="user.id"
                            [disabled]="user.id!.toString() === no_11_userId?.toString() || user.id!.toString() === no_3_userId?.toString() || user.id!.toString() === no_4_userId?.toString()">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select> -->
                </div>
            </div>
        </div>

        <div class="grid">
            <div class="row no-border">
                <div class="column no-border " [style.width]="'100px'">

                </div>
                <div class="column no-border " [style.width]="'160px'">
                    选择会签部门
                </div>
                <div class="column no-border " [style.width]="'100px'">
                    <label>
                        <input type="checkbox" [(ngModel)]="noNeedRest">
                        <span class="{{noNeedRest ? 'color-primary' : ''}}">无需会签</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'40px'">

                </div>
                <div class="column background-page" [style.width]="'120px'">
                    选择部门
                </div>
                <div class="column background-page" [style.width]="'200px'">
                    负责人
                </div>
            </div>
            <div class="row" *ngFor="let department of departments">
                <div class="column" [style.width]="'40px'">
                    <input type="checkbox" [(ngModel)]="department.checked" [disabled]="noNeedRest">

                </div>
                <div class="column {{department.checked ? 'color-primary' : ''}}  {{noNeedRest ? 'color-light' : ''}} text-left"
                    [style.width]="'120px'">
                    {{department.label}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <select [(ngModel)]="selectedUserMap[department.value.toString()]">
                        <option *ngFor="let user of userTreeNodesMap[department.value.toString()] ?? []"
                            [value]="user.id">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确定</button>
    </div>
</div>